import type { PadronCheck } from '../../api/types';

// Nombres de CondicionIVAReceptorId (manual WSFEv1 v4.7).
const CONDITIONS: Record<number, string> = {
  1: 'Responsable Inscripto',
  4: 'Exento',
  5: 'Consumidor Final',
  6: 'Monotributo',
  7: 'No Categorizado',
  8: 'Proveedor del Exterior',
  9: 'Cliente del Exterior',
  10: 'IVA Liberado Ley 19.640',
  13: 'Monotributista Social',
  15: 'IVA No Alcanzado',
  16: 'Monotributo Trabajador Independiente Promovido',
};

const conditionName = (value: string | number | undefined) => {
  const code = Number(value);
  return CONDITIONS[code] ?? String(value ?? '-');
};

export interface PadronCheckView {
  label: string;
  tone: 'approved' | 'pending' | 'draft';
  detail?: string;
}

// Resultado informativo del contraste con el padrón al crear. No se muestra si no hubo verificación
// (comprobantes anteriores, verificación desactivada o receptor sin CUIT).
export function padronCheckView(
  check: PadronCheck | undefined,
  declared: string | number | undefined,
): PadronCheckView | null {
  if (!check || check.status === 'not_applicable') return null;
  switch (check.status) {
    case 'verified':
      return { label: 'coincide con ARCA', tone: 'approved' };
    case 'mismatch':
      return {
        label: 'difiere de ARCA',
        tone: 'pending',
        detail: `Declarada: ${conditionName(declared)}. Según el padrón: ${conditionName(check.condition)}.`,
      };
    case 'not_found':
      return { label: 'CUIT no encontrada', tone: 'pending', detail: 'El padrón de ARCA no tiene registrada la CUIT del receptor.' };
    case 'unavailable':
      return { label: 'no verificada', tone: 'draft', detail: 'No se pudo consultar el padrón al crear el comprobante.' };
    default:
      return { label: 'sin confirmar', tone: 'draft', detail: 'Los datos del padrón no alcanzan para confirmar la condición.' };
  }
}

export function PadronCheckInfo({ check, declared }: { check?: PadronCheck; declared: string | number | undefined }) {
  const view = padronCheckView(check, declared);
  if (!view) return null;
  return (
    <div className="padron-status">
      <div className="row">
        <span>Condición de IVA del receptor:</span>
        <span className={`badge ${view.tone}`}>{view.label}</span>
        {view.detail && <span className="muted">{view.detail}</span>}
      </div>
      <p className="muted padron-note">Verificación informativa al crear: no impide emitir.</p>
    </div>
  );
}
